import {
  createStore,
  combineReducers,
  applyMiddleware,
  AnyAction,
} from 'redux';
import thunkMiddleware, {ThunkAction} from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import {connectRouter, routerMiddleware} from 'connected-react-router';
import {createBrowserHistory, History} from 'history';

import {authReducer} from './Auth/Reducers';
import {homeReducer} from './Home/Reducers';
import {articlesReducer} from './Articles/Reducers';
import {userReducer} from './User/Reducers';
import {adminReducer} from './Admin/Reducers';
import {ticketsReducer} from './Tickets/Reducers';

const rootReducer = (history: History) => combineReducers({
  router: connectRouter(history),
  auth: authReducer,
  home: homeReducer,
  articles: articlesReducer,
  user: userReducer,
  admin: adminReducer,
  tickets: ticketsReducer,
});

export const history = createBrowserHistory();
export type AppState = ReturnType<ReturnType<typeof rootReducer>>;
export type ThunkResult<R> = ThunkAction<R, AppState, undefined, AnyAction>;

export function configureStore() {
  const middlewares = [
    thunkMiddleware,
    routerMiddleware(history),
  ];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(
    rootReducer(history),
    composeWithDevTools(middlewareEnhancer),
  );

  return store;
}

const store = configureStore();

export default store;
